import { Editor } from "@tiptap/core";
import { AppInjector } from "app/app.module";
import { DomHelperService } from "app/global/dom-helper.service";
import { GlobalService } from "app/global/global.service";
import { DatepickerField } from "app/interfaces/datepickerfield";
import { DroplistField } from "app/interfaces/droplistfields";
import { Textfield } from "app/interfaces/textfield";
import { FieldRenderService } from "app/main/pages/edit-template/field-render.service";
import { EditorEmitterService } from "app/main/pages/events/editor-emitter.service";

export function addTag(item, editor:Editor) {
    const fieldRendererService = AppInjector.get(FieldRenderService);
    const globalService = AppInjector.get(GlobalService);
    const editorEmitterService = AppInjector.get(EditorEmitterService);
    const domHelperService = AppInjector.get(DomHelperService);
    let field = {};
    const maxOrder = globalService.getMaxFieldOrder();
    if (item.type == 'textfield') { //TODO: consider dedicated enum instead of hardcoded value
        field = Textfield.tag({ order: maxOrder, type_of: 'tag', tag_view: 1, uuid: item.id, field_info: 'custom_field' });
    } else if (item.type == 'datepicker') {
        field = DatepickerField.tag({ order: maxOrder, type_of: 'tag', tag_view: 1, uuid: item.id, field_info: 'custom_field' });
    } else if (item.type == 'droplist') {
        field = DroplistField.tag({ order: maxOrder, type_of: 'tag', tag_view: 1, uuid: item.id, field_info: 'custom_field' });
    }
    globalService.fields_data[item.id] = field;
    const selected_field = globalService.fields_data[item.id].selected_field;
    const field_name = globalService.fields_data[item.id].field_name;
    editorEmitterService.triggerEmitter({ uuid: item.id, field_name: field_name, selected_field: selected_field, isFormBuilder: 0, formUuid: 0, isFieldBlock: 0, autoOpenDropDown: true, editor: editor.view.dom });
    domHelperService.initializeEventListener('.open-tag-popover', 'click', 'openTagPopover', {role_id:0, hide_settings:false});
    domHelperService.initializeEventListener('.text-tag-editor,.text-field-input,.text-field-textarea', 'keyup', 'updateFieldOnKeyUp', { role_id: 0 });
    domHelperService.initializeEventListener('.text-tag-editor,.text-field-input,.text-field-textarea', 'blur', 'updateFieldOnBlur', { role_id: 0 });
    if(fieldRendererService.isRendered(item.id)) {
        fieldRendererService.markRendered(item.id);
    }   
}